/* global axios */
import ApiClient from '../ApiClient';

const buildCreatePayload = ({
  message,
  scheduledAt,
  files,
  contentAttributes,
}) => {
  if (files?.length) {
    const payload = new FormData();
    if (message) payload.append('content', message);
    payload.append('scheduled_at', scheduledAt);
    files.forEach(file => payload.append('attachments[]', file));
    if (contentAttributes) {
      payload.append('content_attributes', JSON.stringify(contentAttributes));
    }
    return payload;
  }

  return {
    content: message,
    scheduled_at: scheduledAt,
    content_attributes: contentAttributes,
  };
};

class ScheduledMessageApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  list(conversationId) {
    return axios.get(`${this.url}/${conversationId}/scheduled_messages`);
  }

  create({ conversationId, message, scheduledAt, files, contentAttributes }) {
    return axios.post(
      `${this.url}/${conversationId}/scheduled_messages`,
      buildCreatePayload({ message, scheduledAt, files, contentAttributes })
    );
  }

  destroy(conversationId, scheduledMessageId) {
    return axios.delete(
      `${this.url}/${conversationId}/scheduled_messages/${scheduledMessageId}`
    );
  }
}

export default new ScheduledMessageApi();
